import React from 'react'
import { render } from 'react-dom'
import App from './App'
import CreateComponent from "./utils/CreateComponent";

CreateComponent.init();
// render(<App />, document.getElementById('root'))
